<template>
    <div class='component-page'>
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="5">
                    <Input search v-model="formItem.realname" placeholder="教师姓名" @on-search="handleSearch" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
               
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <Modal title="预览" v-model="visible" @on-cancel="cancelVideo">
            <video v-if="visible" :src='videoUrl' controls="controls" autoplay="autoplay" style='margin:0 auto;width:60%;display:block'>
                            <source :src='videoUrl' type="video/mp4">
                            <source :src='videoUrl' type="video/mov">
    
            </video>
            <div slot="footer">
                    <Button type="primary" ghost shape="circle" @click="cancelVideo()">关闭</Button>
            </div>
        </Modal>
         <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        setStatus
    } from '@/api/teacherVideo'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    start_time: '',
                    end_time: '',
                    realname:'',
                },
                start_time: '',
                end_time: '',
                visible:false,
                homework_id:'',
                videoUrl:'',
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    
                    {
                        title: '教师姓名',
                        align: 'center',
                        key: 'realname',
                    },
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'class_name',
                    },
                    {
                        title: '章节名称',
                        align: 'center',
                        key: 'chapter_name',
                    },
                    {
                        title: '课程名称',
                        align: 'center',
                        key: 'lesson_name',
                    },
                    {
                        title: '视频',
                        align: 'center',
                        key: 'video_url',
                        width: 100,
                        render: (h, params) => {
                            return h("video", {
                                attrs: {
                                    src: params.row.video_url
                                },
                                style: {
                                    width: '60px',
                                    height: '60px',
                                    marginTop: '4px',
                                    cursor: 'pointer',
                                },
                                on:{
                                    click: () => {
                                        this.seeVideo(params.row.video_url)
                                    }
                                },
                            })
    
                        }
                    },
                    {
                        title: '是否上架',
                        align: 'center',
                        key: 'is_shelf',
                        render: (h, params) => {
                            if(params.row.is_shelf==1){
                                return h('div', '是')
                            }else{
                                return h('div', '否')
                            }
                        }
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,

                    },
                   
                     {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 120,
                        render: (h, params) => {
                            if(params.row.is_shelf==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.homework_id,'确定上架该视频吗？')
                                            }
                                        }
                                    }, '上架'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.homework_id,'确定下架该视频吗？')
                                            }
                                        }
                                    }, '下架'),
                                ])
                            }
                           
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            seeVideo(url){
                this.videoUrl=url;
                this.visible=true;
            },
            // 改变状态
            changeStatus(id,info){
                this.homework_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                    setStatus({
                        homework_id:this.homework_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                
                
            },
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            cancelVideo(){
                this.visible=false;
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
